import { GlobalAxios } from "../axios/axios-config";
import { IInsuranceRegister } from "../models/insurance-register";
import {
  ITicketAutomationReceivedMessagePrivateInsurance,
  ITicketAutomationReceivedMessagePrivateInsuranceParams,
} from "../models/ticket-automation-received-message-private-insurance";

const TICKET_AUTOMATION_RECEIVED_MESSAGE_PRIVATE_INSURANCE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedMessagePrivateInsurance/";

const INSURANCE_REGISTER_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InsuranceRegister/CalendarRegister";

export const createTicketAutomationReceivedMessagePrivateInsurance = (
  item: ITicketAutomationReceivedMessagePrivateInsurance
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_MESSAGE_PRIVATE_INSURANCE,
    item
  );
};

export const getTicketAutomationReceivedMessagePrivateInsuranceById = (
  id: string
) => {
  return GlobalAxios.get<ITicketAutomationReceivedMessagePrivateInsurance>(
    TICKET_AUTOMATION_RECEIVED_MESSAGE_PRIVATE_INSURANCE + id
  );
};

export const updateTicketAutomationReceivedMessagePrivateInsuranceById = ({
  id,
  item,
}: ITicketAutomationReceivedMessagePrivateInsuranceParams) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_MESSAGE_PRIVATE_INSURANCE + id,
    item
  );
};

export const privateInsuranceRegisterList = (params?: any) => {
  return GlobalAxios.get<IInsuranceRegister[]>(INSURANCE_REGISTER_ROUTE, {
    params: params,
    paramsSerializer: {
      indexes: null,
    },
  });
};
